import React, { Component } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import Sidebar from "../../common/Sidebar";
import Topbar from "../../common/Topbar";
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray } from "../../common/Global/commonFunctions";
import * as Constants from '../../common/Global/constants';
import { AddNewButtonLayout, SearchSpan } from "../../common/Global/globalStyles.style";
import AddRootFrameworkDialog from "./addrootframeworkdialog";
import TableDropDown from "../../common/DropdownMenus/TableDropdown";
import AlertDialog from "../../common/AlertDialog";
import FrameworkDialog from "./frameworkTree";
import Pagination from "../../common/Global/pagination";
import FilterDropDown from "../../common/DropdownMenus/FilterDropdown";
import FrameworkInfoDialog from "./frameworkInfoDialog";
import FrameworkLinkDialog from "./frameworkLinkDialog";
import FrameworkAccessDialog from "./frameworkAccessDialog";
import AddFrameworkRepealed from "./addFrameworkRepealed";

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();
const activeStatus = "active";
const repealedStatus = "repealed";
const activeStatusLabel = "Active";
const repealedStatusLabel = "Repealed";

class Framework extends Component {
    constructor (props) {
        super(props);
        this.state = {
            showLoader: false,
            componentDidMountFlag: false,
            currentPageNo: 1,
            resultSize:Constants.RESULT_SIZE_GRID,
            resultSizePlaceholder:Constants.RESULT_SIZE_GRID,
            totalCount:0,
            searchkey: "",
            selectedItem:"",
            status:activeStatus,
            statusPlaceholder:"Active",
            statusArr:[
                {
                    label:activeStatus,
                    displayLabel:activeStatusLabel,
                    isSelected:true
                },
                {
                    label:repealedStatus,
                    displayLabel:repealedStatusLabel,
                    isSelected:false
                },
            ],
            frameworks: [],
            showCreateDialog: false,
            isEdit: false,
            selectedId: "",
            frameworkName: "",
            rootFrameworkId: "",
            previousVersionArr:[],
            resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_GRID_DD_ARR)),
            showInfoDialog:false,
            showLinkDialog:false,
            showClientAccessDialog:false,
            showRepealedDialog:false
        }
        themeSettings = getThemeSettingsVariables();
        userDetails = getLocalStorageVariables();
    }
    
    componentDidMount () {
        this.getInitData();
    }

    getInitData = () => {
        this.getFrameworkMasterList();
    }

    // Handle result size dropdown click
    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            currentPageNo:1,
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getFrameworkMasterList();
        })
    }

    // Handle search input change
    handleChangeSearch = (e) => {
        const { name, value } = e.target;
        this.setState({ 
            [name]: value
        });
    }

    // Handle enter button press
    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.setState({
                currentPageNo:1
            },()=>{
                this.getFrameworkMasterList();
            })
        }
    }

    // Handle search icon click
    onSearchIconClick = () => {
        this.setState({
            currentPageNo:1
        },()=>{
            this.getFrameworkMasterList();
        })
    }

    // Handle status dropdown click
    statusDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.statusArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.displayLabel;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            currentPageNo:1,
            statusArr:tempArr,
            status:item.label,
            statusPlaceholder:placeholder
        }, () => {
            this.getFrameworkMasterList();
        })
    }

    // Method to handle add/edit framework dialog show
    handleCreateDialogShow = () => {
        this.setState({
            showCreateDialog: true,
            isEdit: false,
            selectedId: "",
            frameworkName: "",
            rootFrameworkId: "",
        });
    }

    // Method to handle add/edit framework dialog close
    handleAddEditDialogClose = (reloadFlag) => {
        this.setState({
            isEdit: false,
            showCreateDialog: false,
        },()=>{
            if(reloadFlag) this.getFrameworkMasterList();
        })
    }

    onTableDropDownItemClick = (item, dropdownItem) => {
        if(item.label === "Delete"){
            this.setState({
                alertDialogHeading:"Delete Framework",
                proceedBtnLabel:"Delete",
                deleteFrameworkId:dropdownItem.frameworkId,
                showAlertDialog:true,
                alertDialogMessage:"Are you sure you want to delete framework "+dropdownItem.frameworkName+"?"
            })
        }else if(item.label === "Edit"){
            this.setState({
                showCreateDialog:true,
                isEdit:true,
                selectedItem:dropdownItem
            });
        }else if(item.label === "Info"){
            this.setState({
                showInfoDialog:true,
                selectedFrameworkId:dropdownItem.frameworkId,
                isInfoEdit:dropdownItem.status == activeStatus
            })
        }else if(item.label === "Link"){
            this.setState({
                showLinkDialog:true,
                rootFrameworkId:dropdownItem.frameworkId,
                frameworkName:dropdownItem.frameworkName,
            })
        }else if(item.label === "Repealed"){
            this.setState({
                showRepealedDialog:true,
                selectedFrameworkId:dropdownItem.frameworkId
            })
        }
    }

    // Method to handle framework tree dialog show
    showFrameworkTreeDialog = (item) => {
        this.setState({
            showFrameworkTreeDialog:true,
            rootFrameworkId:item.frameworkId,
            rootNode:item,
            isEdit:item.status == activeStatus
        })
    }

    // Method to handle alert dialog close
    handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog: false,
            alertDialogMessage: "",
        });
    }

    // Method to handle framework tree dialog close
    handleFrameworkTreeDialogClose = (reloadFlag) => {
        this.setState({
            showFrameworkTreeDialog:false,
            rootFrameworkId:"",
            isEdit:false
        },()=>{
            if(reloadFlag == true) this.getFrameworkMasterList();
        })
    }

    // Handle pagination click
    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            this.getFrameworkMasterList(page);
        }
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Handle framework info alert dialog close event
    handleInfoDialogClose = () => {
        this.setState({
            showInfoDialog:false,
            selectedFrameworkId:"",
            isInfoEdit:false
        })
    }

    // Handle framework link alert dialog close event
    handleLinkDialogClose = () => {
        this.setState({
            showLinkDialog:false
        })
    }

    // Handle client access dialog show
    handleClientAccess = () => {
        this.setState({
            showClientAccessDialog:true
        })
    }

    // Handle framework access dialog close event
    handleAccessDialogClose = () => {
        this.setState({
            showClientAccessDialog:false
        })
    }

    // Handle Repealed dialog close event
    handleRepealedDialogClose = (reloadFlag) => {
        this.setState({
            showRepealedDialog:false,
            selectedFrameworkId:""
        }, () => {
            if(reloadFlag == true){
                this.getFrameworkMasterList();
            }
        })
    }

    /*******************API CALLS*******************/
    getFrameworkMasterList = (page = null) => {
        this.setState({
            showLoader:true,
        });
        const pageNo = page || this.state.currentPageNo;
        fetch(Constants.GetRootFramework, {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                pageNo:pageNo,
                search:this.state.searchkey,
                status:this.state.status,
                resultsize:this.state.resultSize,
            })
        })
        .then(res => res.json())
        .then(res => {
            let frameworks = [];
            let previousVersionArr = [];
            if(handleTokenExpiry(res.responseCode)) return;
            else if(res.responseCode === Constants.CODE_SUCCESS){
                frameworks = res.data.result;
                previousVersionArr = frameworks.map(item => {
                    return {
                        previousVersion: item.frameworkName,
                        frameworkId: item.frameworkId
                    }
                })
            }
            this.setState({
                showLoader: false,
                frameworks: frameworks,
                totalCount: res.data?.count ?? 0,
                previousVersionArr:previousVersionArr,
                componentDidMountFlag: true,
                currentPageNo: pageNo,
            });
        })
    }

    handleRecordOperation = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.DeleteFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.state.deleteFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    deleteFrameworkId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    actionType:"",
                },() => {
                    this.getFrameworkMasterList();
                });
            }else{
                this.setState({
                    showLoader:false,
                    deleteFrameworkId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    actionType:"",
                    showAlertDialog:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }
    /*******************API CALLS END HERE*******************/

    render () {
        const actionArr = [
            {icon: "info", label: "Info"},
            {icon: "link", label: "Link"},
            {icon: "info", label: "Repealed"},
            {icon: "edit", label: "Edit"},
            {icon: "delete", label: "Delete"},
        ]

        const repealedActionArr = [
            {icon: "info", label: "Info"},
            {icon: "link", label: "Link"},
        ]
        return (
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />

                                { 
                                    this.state.showLoader && 
                                    <div class="loader"></div>
                                }

                                {
                                    this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="search-addnew-bg">
                                            <div className="search-addnew">
                                                <div className="search-filter-layout">
                                                    <FilterDropDown
                                                        placeholder={this.state.resultSizePlaceholder}
                                                        dropdownArr={this.state.resultSizeArr}
                                                        onDropDownItemClick={this.resultSizeDropdownClick}
                                                        themeSettings={themeSettings}
                                                        mleft={0}
                                                    />
                                                    <div className="search-col m-l-10">
                                                        <input 
                                                            name="searchkey" 
                                                            type="text"
                                                            onChange={this.handleChangeSearch}
                                                            placeholder="Search" 
                                                            onKeyPress={this.onEnterBtnPress}
                                                            value={this.state.searchkey}
                                                        />
                                                        <SearchSpan 
                                                            themeSettings={themeSettings}
                                                            onClick = {this.onSearchIconClick}
                                                            className="material-icons"
                                                        >
                                                            search
                                                        </SearchSpan>
                                                    </div>
                                                    <FilterDropDown
                                                        placeholder={this.state.statusPlaceholder}
                                                        dropdownArr={this.state.statusArr}
                                                        onDropDownItemClick={this.statusDropdownClick}
                                                        themeSettings={themeSettings}
                                                        name={"displayLabel"}
                                                    />
                                                </div>
                                                <div className="flex-center-layout">
                                                    <AddNewButtonLayout themeSettings={themeSettings}>
                                                        <a onClick={this.handleClientAccess} href="javascript:void(0);"  style={{marginRight:10}}>
                                                            <span className="material-icons">add_circle</span>
                                                            <p>Client Access</p>
                                                        </a>
                                                    </AddNewButtonLayout>
                                                    <AddNewButtonLayout themeSettings={themeSettings}>
                                                        <a onClick={this.handleCreateDialogShow} href="javascript:void(0);">
                                                            <span className="material-icons">add_circle</span>
                                                            <p>Add New</p>
                                                        </a>
                                                    </AddNewButtonLayout>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    {this.state.frameworks.map((item, idx) => {
                                        let marTop = 10;
                                        if(idx === 0 || idx === 1 || idx === 2){
                                            marTop=0;
                                        }

                                        return (
                                            <div className="col-md-4 custom-col-5" key={item.frameworkName}>
                                                <div
                                                    onClick={this.showFrameworkTreeDialog.bind(this, item)}
                                                    className="tree-list-card-layout c-pointer"
                                                    style={{marginTop:marTop}}
                                                >
                                                    <div className="tree-card-text-layout">
                                                        <p className="font-bold font-bold-resize">{item.frameworkName}</p>
                                                    </div>
                                                    <div className="action-dd-layout">
                                                        <TableDropDown
                                                            actionArr={item.status == activeStatus ? actionArr : repealedActionArr}
                                                            onDropDownItemClick = {this.onTableDropDownItemClick}
                                                            dropDownId = {item}
                                                            dropdownWidth={"120px"}
                                                            themeSettings={themeSettings}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                
                                <div className="pagination-layout">
                                    <div className="row custom-row">
                                        <div className="col-md-9 custom-col">
                                        {
                                            (this.state.totalCount > this.state.frameworks.length) && 
                                            <Pagination 
                                                totalLength ={this.state.totalCount} 
                                                items={this.state.frameworks} 
                                                onChangePage={this.onChangePage} 
                                                pageSize={this.state.resultSize}
                                                currentPageNo = {this.state.currentPageNo}
                                                initialPage={this.state.currentPageNo} 
                                                themeSettings={themeSettings}/>
                                        }
                                        </div>
                                        <div className="col-md-3 custom-col">
                                            <p>{"Total Records: "+this.state.totalCount}</p>
                                        </div>
                                    </div>
                                </div>
                                {this.state.componentDidMountFlag &&
                                    isEmptyArray(this.state.frameworks) &&
                                    <div class="no-items-layout">
                                        <div class="no-items-card">
                                            <h6>
                                                {Constants.NO_FRAMEWORKS_FOUND}
                                            </h6>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                        <AddRootFrameworkDialog
                            isEdit={this.state.isEdit}
                            showCreateDialog={this.state.showCreateDialog}
                            handleAddEditDialogClose={this.handleAddEditDialogClose}
                            previousVersionArr={this.state.previousVersionArr}
                            selectedItem={this.state.selectedItem}
                            themeSettings={themeSettings}
                        />

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialog}
                            handleAlertDialogClose={this.handleAlertDialogClose}
                            type={Constants.ALERT_TYPE_WARNING}
                            alertDialogHeading={this.state.alertDialogHeading}
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.handleRecordOperation}
                            proceedBtnLabel={this.state.proceedBtnLabel}
                            themeSettings={themeSettings}
                        />

                        <AlertDialog 
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings={themeSettings}
                        />

                        <FrameworkDialog
                            showFrameworkTreeDialog={this.state.showFrameworkTreeDialog}
                            handleFrameworkTreeDialogClose={this.handleFrameworkTreeDialogClose}
                            rootFrameworkId={this.state.rootFrameworkId}
                            rootNode={this.state.rootNode}
                            isFrameworkEdit={this.state.isEdit}
                            themeSettings={themeSettings}
                            activeFlag={"N"}
                        />

                        <FrameworkInfoDialog
                            showInfoDialog={this.state.showInfoDialog}
                            handleInfoDialogClose={this.handleInfoDialogClose}
                            themeSettings={themeSettings}
                            isInfoEdit={this.state.isInfoEdit}
                            selectedFrameworkId={this.state.selectedFrameworkId}
                        />

                        <FrameworkLinkDialog
                            showLinkDialog={this.state.showLinkDialog}
                            handleLinkDialogClose={this.handleLinkDialogClose}
                            rootFrameworkId={this.state.rootFrameworkId}
                            frameworkName={this.state.frameworkName}
                            themeSettings={themeSettings}
                        />

                        <FrameworkAccessDialog
                            showClientAccessDialog={this.state.showClientAccessDialog}
                            handleAccessDialogClose={this.handleAccessDialogClose}
                            themeSettings={themeSettings}
                        />

                        <AddFrameworkRepealed
                            showRepealedDialog={this.state.showRepealedDialog}
                            handleRepealedDialogClose={this.handleRepealedDialogClose}
                            themeSettings={themeSettings}
                            frameworkId={this.state.selectedFrameworkId}
                        />
                    </section>
                </main>
            </Router>
        )
    }
}

export default Framework
